// assets/theme.js

// Fisher-Yates shuffle for unbiased randomization
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

// Shuffle review cards to vary content order
function shuffleReviewCards() {
  document.querySelectorAll('[data-reviews-track]').forEach(track => {
    const cards = Array.from(track.querySelectorAll('.review-card'));
    if (cards.length <= 1) return;

    shuffleArray(cards);
    cards.forEach(card => track.appendChild(card));
  });
}

document.addEventListener('DOMContentLoaded', function() {

  document.body.classList.add('js');
  // --- Dropdown Menu Logic ---
  const navItemToggles = document.querySelectorAll('[data-nav-item-toggle]');

  navItemToggles.forEach(toggle => {
    toggle.addEventListener('click', function(event) {
      const parentLi = this.closest('.nav-item');
      if (!parentLi) return;

      const subMenu = parentLi.querySelector('.nav-sub');
      if (!subMenu) return;

      if (this.getAttribute('href') === '#') {
         event.preventDefault();
      }

      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.nav-sub.is-open').forEach(openSubMenu => {
        if (openSubMenu !== subMenu) {
          openSubMenu.classList.remove('is-open');
          const otherToggle = openSubMenu.closest('.nav-item')?.querySelector('[data-nav-item-toggle]');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        }
      });

      subMenu.classList.toggle('is-open');
      this.setAttribute('aria-expanded', !isExpanded);

    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(event) {
    if (!event.target.closest('.site-header-nav')) {
      document.querySelectorAll('.nav-sub.is-open').forEach(openSubMenu => {
        openSubMenu.classList.remove('is-open');
        const toggle = openSubMenu.closest('.nav-item')?.querySelector('[data-nav-item-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // --- Phone menu: More panel holds the links that do not fit in the bar ---
  const moreToggle = document.querySelector('[data-nav-more-toggle]');
  const morePanel = document.getElementById('nav-more-panel');
  const setMoreOpen = (open) => {
    if (!moreToggle || !morePanel) return;
    moreToggle.setAttribute('aria-expanded', String(open));
    morePanel.hidden = !open;
  };

  if (moreToggle && morePanel) {
    moreToggle.addEventListener('click', () => {
      setMoreOpen(moreToggle.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.site-header-nav')) setMoreOpen(false);
    });
  }

  // Close on ESC for accessibility
  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.nav-sub.is-open').forEach(menu => menu.classList.remove('is-open'));
      navItemToggles.forEach(t => t.setAttribute('aria-expanded', 'false'));
      if (moreToggle && moreToggle.getAttribute('aria-expanded') === 'true') {
        setMoreOpen(false);
        moreToggle.focus();
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', shuffleReviewCards);

// --- Reviews carousel (scroll-snap) ---
function initReviewsCarousel() {
  document.querySelectorAll('[data-reviews-section]').forEach(section => {
    const viewport = section.querySelector('[data-reviews-viewport]');
    const track = section.querySelector('[data-reviews-track]');
    if (!viewport || !track || viewport.dataset.carouselInitialized === 'true') return;

    const prev = section.querySelector('[data-reviews-prev]');
    const next = section.querySelector('[data-reviews-next]');
    const SCROLL_TOLERANCE = 2;

    viewport.dataset.carouselInitialized = 'true';

    // Scroll by the first visible card width plus the track gap.
    const calculateScrollAmount = () => {
      const firstCard = track.querySelector('.review-card:not([hidden])');
      if (!firstCard) return viewport.clientWidth;
      const trackStyle = window.getComputedStyle(track);
      const gap = parseFloat(trackStyle.gap) || 25;
      return firstCard.offsetWidth + gap;
    };

    prev?.addEventListener('click', () => {
      const scrollAmount = calculateScrollAmount();
      if (viewport.scrollLeft <= SCROLL_TOLERANCE) {
        viewport.scrollTo({ left: viewport.scrollWidth, behavior: 'smooth' });
      } else {
        viewport.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      }
    });

    next?.addEventListener('click', () => {
      const scrollAmount = calculateScrollAmount();
      if (viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - SCROLL_TOLERANCE) {
        viewport.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        viewport.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    });
  });
}

function initReviewsFilters() {
  document.querySelectorAll('[data-reviews-section]').forEach(section => {
    if (section.dataset.filtersInitialized === 'true') return;

    const filterButtons = Array.from(section.querySelectorAll('[data-review-filter]'));
    const cards = Array.from(section.querySelectorAll('.review-card[data-review-tags]'));
    const viewport = section.querySelector('[data-reviews-viewport]');
    const count = section.querySelector('[data-reviews-count]');
    const emptyState = section.querySelector('[data-reviews-filter-empty]');
    const prev = section.querySelector('[data-reviews-prev]');
    const next = section.querySelector('[data-reviews-next]');

    if (filterButtons.length === 0 || cards.length === 0) return;

    section.dataset.filtersInitialized = 'true';

    const applyFilter = filter => {
      let visibleCount = 0;

      cards.forEach(card => {
        const tags = card.dataset.reviewTags.trim().split(/\s+/).filter(Boolean);
        const isVisible = filter === 'all' || tags.includes(filter);
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      filterButtons.forEach(button => {
        const isActive = button.dataset.reviewFilter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (count) count.textContent = String(visibleCount);
      if (emptyState) emptyState.hidden = visibleCount !== 0;
      if (viewport) {
        viewport.hidden = visibleCount === 0;
        viewport.scrollTo({ left: 0, behavior: 'auto' });
      }
      if (prev) prev.hidden = visibleCount <= 1;
      if (next) next.hidden = visibleCount <= 1;
    };

    filterButtons.forEach(button => {
      button.addEventListener('click', () => applyFilter(button.dataset.reviewFilter));
    });

    applyFilter('all');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initReviewsCarousel();
  initReviewsFilters();
});

document.addEventListener('shopify:section:load', event => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  if (target.matches('[data-reviews-section]') || target.querySelector('[data-reviews-section]')) {
    initReviewsCarousel();
    initReviewsFilters();
  }
});

// --- Benefits carousel (scroll-snap) ---
function initBenefitsCarousel() {
  const viewport = document.querySelector('[data-benefits-viewport]');
  const track = document.querySelector('[data-benefits-track]');
  if (!viewport || !track) return;

  const prev = document.querySelector('[data-benefits-prev]');
  const next = document.querySelector('[data-benefits-next]');

  const SCROLL_TOLERANCE = 2;

  const calculateScrollAmount = () => {
    const firstCard = track.querySelector('.benefits-card');
    if (!firstCard) return viewport.clientWidth;
    const trackStyle = window.getComputedStyle(track);
    const gap = parseFloat(trackStyle.gap) || 25;
    return firstCard.offsetWidth + gap;
  }

  prev?.addEventListener('click', () => {
    const scrollAmount = calculateScrollAmount();
    if (viewport.scrollLeft <= SCROLL_TOLERANCE) {
      viewport.scrollTo({ left: viewport.scrollWidth, behavior: 'smooth' });
    } else {
      viewport.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  });
  
  next?.addEventListener('click', () => {
    const scrollAmount = calculateScrollAmount();
    if (viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - SCROLL_TOLERANCE) {
      viewport.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      viewport.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  });
}

document.addEventListener('DOMContentLoaded', initBenefitsCarousel);

// --- Video carousel (scroll-snap) ---
function initVideoCarousel() {
  const viewport = document.querySelector('[data-video-viewport]');
  const track = document.querySelector('[data-video-track]');
  if (!viewport || !track) return;

  const prev = document.querySelector('[data-video-prev]');
  const next = document.querySelector('[data-video-next]');

  const SCROLL_TOLERANCE = 2;

  const calculateScrollAmount = () => {
    const firstCard = track.querySelector('.video-card');
    if (!firstCard) return viewport.clientWidth;
    const trackStyle = window.getComputedStyle(track);
    const gap = parseFloat(trackStyle.gap) || 20;
    return firstCard.offsetWidth + gap;
  }

  prev?.addEventListener('click', () => {
    const scrollAmount = calculateScrollAmount();
    if (viewport.scrollLeft <= SCROLL_TOLERANCE) {
      viewport.scrollTo({ left: viewport.scrollWidth, behavior: 'smooth' });
    } else {
      viewport.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  });

  next?.addEventListener('click', () => {
    const scrollAmount = calculateScrollAmount();
    if (viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - SCROLL_TOLERANCE) {
      viewport.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      viewport.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  });
}

document.addEventListener('DOMContentLoaded', initVideoCarousel);

// --- Before/After carousel (scroll-snap) ---
function initBeforeAfterCarousel() {
  document.querySelectorAll('[data-before-after-section]').forEach(section => {
    const viewport = section.querySelector('[data-before-after-viewport]');
    const track = section.querySelector('[data-before-after-track]');
    if (!viewport || !track || viewport.dataset.carouselInitialized === 'true') return;

    const prev = section.querySelector('[data-before-after-prev]');
    const next = section.querySelector('[data-before-after-next]');
    const SCROLL_TOLERANCE = 2;

    viewport.dataset.carouselInitialized = 'true';

    const calculateScrollAmount = () => {
      const firstCard = track.querySelector('.review-card-item:not([hidden])');
      if (!firstCard) return viewport.clientWidth;
      const trackStyle = window.getComputedStyle(track);
      const gap = parseFloat(trackStyle.gap) || 30;
      return firstCard.offsetWidth + gap;
    };

    prev?.addEventListener('click', () => {
      const scrollAmount = calculateScrollAmount();
      if (viewport.scrollLeft <= SCROLL_TOLERANCE) {
        viewport.scrollTo({ left: viewport.scrollWidth, behavior: 'smooth' });
      } else {
        viewport.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      }
    });

    next?.addEventListener('click', () => {
      const scrollAmount = calculateScrollAmount();
      if (viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - SCROLL_TOLERANCE) {
        viewport.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        viewport.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    });
  });
}

function initBeforeAfterFilters() {
  document.querySelectorAll('[data-before-after-section]').forEach(section => {
    if (section.dataset.filtersInitialized === 'true') return;

    const filterButtons = Array.from(section.querySelectorAll('[data-before-after-filter]'));
    const cards = Array.from(section.querySelectorAll('.review-card-item[data-before-after-tags]'));
    const viewport = section.querySelector('[data-before-after-viewport]');
    const count = section.querySelector('[data-before-after-count]');
    const emptyState = section.querySelector('[data-before-after-filter-empty]');
    const prev = section.querySelector('[data-before-after-prev]');
    const next = section.querySelector('[data-before-after-next]');

    if (filterButtons.length === 0 || cards.length === 0) return;

    section.dataset.filtersInitialized = 'true';

    const applyFilter = filter => {
      let visibleCount = 0;

      cards.forEach(card => {
        const tags = card.dataset.beforeAfterTags.trim().split(/\s+/).filter(Boolean);
        const isVisible = filter === 'all' || tags.includes(filter);
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      filterButtons.forEach(button => {
        const isActive = button.dataset.beforeAfterFilter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (count) count.textContent = String(visibleCount);
      if (emptyState) emptyState.hidden = visibleCount !== 0;
      if (viewport) {
        viewport.hidden = visibleCount === 0;
        viewport.scrollTo({ left: 0, behavior: 'auto' });
      }
      if (prev) prev.hidden = visibleCount <= 1;
      if (next) next.hidden = visibleCount <= 1;
    };

    filterButtons.forEach(button => {
      button.addEventListener('click', () => applyFilter(button.dataset.beforeAfterFilter));
    });

    applyFilter('all');
  });
}

function initBeforeAfterSections() {
  initBeforeAfterCarousel();
  initBeforeAfterFilters();
}

document.addEventListener('DOMContentLoaded', initBeforeAfterSections);

document.addEventListener('shopify:section:load', event => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  if (target.matches('[data-before-after-section]') || target.querySelector('[data-before-after-section]')) {
    initBeforeAfterSections();
  }
});

// --- Back to Top Button ---
function initBackToTop() {
  const backToTopButton = document.querySelector('.back-to-top');
  if (!backToTopButton) return;

  const scrollThreshold = 300;

  window.addEventListener('scroll', () => {
    if (window.scrollY > scrollThreshold) {
      backToTopButton.classList.add('back-to-top--visible');
    } else {
      backToTopButton.classList.remove('back-to-top--visible');
    }
  });

  backToTopButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}
document.addEventListener('DOMContentLoaded', initBackToTop);

// --- Product gallery: thumbnails follow the scroll-snap track ---
function initProductGallery() {
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const track = gallery.querySelector('[data-gallery-track]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const slides = track ? Array.from(track.children) : [];
    if (!track || slides.length === 0 || thumbs.length === 0) return;

    const setActive = (index) => {
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', event => {
        event.preventDefault();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        setActive(index);
      });
    });

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) setActive(slides.indexOf(entry.target));
      });
    }, { root: track, threshold: 0.6 });
    slides.forEach(slide => observer.observe(slide));
  });
}
document.addEventListener('DOMContentLoaded', initProductGallery);

// --- Sticky buy bar: visible while the main buy button is off screen ---
function initStickyBuy() {
  const bar = document.querySelector('[data-sticky-buy]');
  const buy = document.querySelector('[data-product-buy]');
  if (!bar || !buy) return;

  bar.hidden = false;
  const observer = new IntersectionObserver(([entry]) => {
    const show = !entry.isIntersecting;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', String(!show));
    bar.inert = !show;
    document.body.classList.toggle('has-sticky-buy', show);
  });
  observer.observe(buy);
}
document.addEventListener('DOMContentLoaded', initStickyBuy);

// --- ECharts: shared sizing ---
// Size each chart by its own box, not the window: a bento card on a tablet is as narrow as a phone.
function isCompactChart(chartDom) {
  return chartDom.clientWidth < 520;
}

// Axis names start at the axis line instead of centring on it, so long names stay inside the canvas.
// axisNameTop gives the grid.top that fits a name of that many lines above the plot.
function axisNameStyle(compact) {
  return {
    nameGap: 12,
    nameTextStyle: {
      align: 'left',
      fontSize: compact ? 12 : 13,
      lineHeight: compact ? 15 : 17,
      color: '#555'
    }
  };
}

function axisNameTop(lines, compact) {
  return lines * (compact ? 15 : 17) + 24;
}

// --- ECharts: Pre-Clinical Study Bar Chart ---
function initPreclinicalChart() {
  const chartDom = document.getElementById('preclinical-chart');
  if (!chartDom || typeof echarts === 'undefined') {
    return;
  }

  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#f15e2f';

  const isMobile = isCompactChart(chartDom);
  
  const symbolSize = isMobile ? 40 : 70;
  const fontSize = isMobile ? 16 : 25;
  const padding = isMobile ? 2 : 4;

  const myChart = echarts.init(chartDom);
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: function(params) {
        const dataIndex = params[0].dataIndex;
        const value = params[0].value;
        if (dataIndex === 0) {
          return 'Conventional Glutathione<br/>Liver GSH increase: +' + value + '%<br/><span style="opacity: 0.8">(Mean ± SD: 48 ± 9%)</span>';
        } else if (dataIndex === 1) {
          return 'N-Acetyl Cysteine (NAC)<br/>Liver GSH increase: +' + value + '%<br/><span style="opacity: 0.8">(Mean ± SD: 65 ± 11%)</span>';
        } else {
          return 'Eslite S-Acetyl Glutathione<br/>Liver GSH increase: +' + value + '%<br/><span style="opacity: 0.8">(Mean ± SD: 142 ± 18%, p<0.01 vs NAC and GSH)</span>';
        }
      }
    },
    title: {
      text: '',
      left: 'left'
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '8%',
      top: axisNameTop(2, isMobile),
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: isMobile
        ? ['Conventional\nGlutathione', 'NAC\n(Standard\nAntidote)', 'Eslite\nS-Acetyl\nGlutathione']
        : ['Conventional\nGlutathione', 'NAC\n(Standard Antidote)', 'Eslite\nS-Acetyl Glutathione'],
      axisLabel: {
        interval: 0
      }
    },
    yAxis: {
      type: 'value',
      name: 'Liver GSH Increase (%)\nAfter Medication-Induced Stress',
      ...axisNameStyle(isMobile),
      min: 0,
      max: 160,
      interval: 40
    },
    series: [{
      data: [
        { 
          value: 50,
          itemStyle: { color: '#6c99bb' }
        },
        { 
          value: 66,
          itemStyle: { color: '#8fb3d9' }
        },
        { 
          value: 140, 
          itemStyle: { color: primaryColor }
        }
      ],
      type: 'bar',
      barWidth: '50%',
      showBackground: true,
      backgroundStyle: {
        color: 'rgba(220, 220, 220, 0.2)'
      },
      markLine: {
        silent: true,
        symbol: ['none', 'none'],
        lineStyle: {
          type: 'solid',
          color: '#666',
          width: 1.5
        },
        data: [
          [{ xAxis: 0, yAxis: 39 }, { xAxis: 0, yAxis: 59 }], // GSH error bars: 48±9%
          [{ xAxis: 1, yAxis: 54 }, { xAxis: 1, yAxis: 77 }], // NAC error bars: 65±11%
          [{ xAxis: 2, yAxis: 124 }, { xAxis: 2, yAxis: 160 }], // SAG error bars: 142±18%
          [{ xAxis: -0.05, yAxis: 39 }, { xAxis: 0.05, yAxis: 39 }], // GSH crossbar bottom
          [{ xAxis: -0.05, yAxis: 59 }, { xAxis: 0.05, yAxis: 59 }], // GSH crossbar top
          [{ xAxis: 0.95, yAxis: 54 }, { xAxis: 1.05, yAxis: 54 }], // NAC crossbar bottom
          [{ xAxis: 0.95, yAxis: 77 }, { xAxis: 1.05, yAxis: 77 }], // NAC crossbar top
          [{ xAxis: 1.95, yAxis: 124 }, { xAxis: 2.05, yAxis: 124 }], // SAG crossbar bottom
          [{ xAxis: 1.95, yAxis: 160 }, { xAxis: 2.05, yAxis: 160 }]  // SAG crossbar top
        ]
      },
      markPoint: {
        symbol: 'circle',
        symbolSize: isMobile ? 60 : 70, // Further increased circle size for both mobile and desktop
        itemStyle: {
          color: '#fff',
          borderColor: primaryColor,
          borderWidth: isMobile ? 2 : 3 // Thinner on mobile for space
        },
        label: {
          color: primaryColor,
          fontSize: isMobile ? 14 : 17, // '+140%' needs room inside the 70px circle
          fontWeight: 'bold',
          padding: [padding, padding, padding, padding]
        },
        data: [
          { 
            name: '+140%', 
            value: '+140%', 
            xAxis: 2, 
            yAxis: 150, // Above bar for visibility
            label: { show: true, formatter: '{b}' } 
          }
        ]
      }
    }]
  };

  myChart.setOption(option);

  // Add citation below chart for scientific credibility
  const addCitation = () => {
    const bentoCard = chartDom.closest('.bento-card');
    let citation = bentoCard.querySelector('.chart-citation');
    
    if (!citation) {
      citation = document.createElement('div');
      citation.className = 'chart-citation';
      citation.innerHTML = 'Source: Gnosis by Lesaffre pre-clinical study on paracetamol-induced liver stress';
      bentoCard.appendChild(citation);
    }
  };
  
  // Delay ensures chart renders before citation positioning
  setTimeout(addCitation, 500);

  // Responsive chart behavior on window resize
  window.addEventListener('resize', function() {
    myChart.resize();
    
    const newIsMobile = isCompactChart(chartDom);
    if (newIsMobile !== isMobile) {
      // Re-render chart when switching between mobile/desktop layouts
      setTimeout(initPreclinicalChart, 300);
    }
  });
}

// Initialize the chart after the DOM is loaded

// --- ECharts: Clinical Study Bar Chart ---
function initClinicalChart() {
  const chartDom = document.getElementById('clinical-chart');
  if (!chartDom || typeof echarts === 'undefined') { // Check if element and ECharts library exist
    return;
  }

  // Get the primary theme color from CSS variables
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#f15e2f'; // Fallback orange

  // Use the compact layout when the chart box is narrow
  const isMobile = isCompactChart(chartDom);
  
  // Set responsive sizes based on device
  const symbolSize = isMobile ? 60 : 70; // Consistent with other charts
  const fontSize = isMobile ? 14 : 20;   // Smaller text for percentages
  const padding = isMobile ? 2 : 4;      // Less padding on mobile

  const myChart = echarts.init(chartDom);
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: function(params) {
        // More detailed tooltip with study reference
        const dataIndex = params[0].dataIndex;
        const value = params[0].value;
        if (dataIndex === 0) {
          return 'Regular Commercial Glutathione<br/>Plasma GSH AUC₀₋₂₄ₕ: ' + value + ' μM·h';
        } else {
          return 'Eslite S-Acetyl Glutathione<br/>Plasma GSH AUC₀₋₂₄ₕ: ' + value + ' μM·h<br/><span style="opacity: 0.8">(69% higher, p<0.05)</span>';
        }
      }
    },
    grid: { // Add padding
      left: '3%',
      right: '4%',
      bottom: '8%', // Increased for citation text
      top: axisNameTop(3, isMobile),
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: isMobile
        ? ['Regular\nCommercial\nGlutathione', 'Eslite\nS-Acetyl\nGlutathione']
        : ['Regular Commercial\nGlutathione', 'Eslite\nS-Acetyl Glutathione'],
      axisLabel: { interval: 0 } // Remove rotation, allow multi-line
    },
    yAxis: {
      type: 'value',
      name: 'Plasma GSH\nArea Under the Curve\n(AUC₀₋₂₄ₕ, μM·h)', // Updated with precise term from study
      ...axisNameStyle(isMobile),
      min: 0,
      max: 600, // Updated to accommodate the new scale
      interval: 100 // Updated interval for the new scale
    },
    series: [{
      data: [
        { 
          value: 231,  // Value from study (approximate based on AUC being 69% lower than SAG)
          itemStyle: { color: '#6c99bb' }, // Different color for conventional glutathione
          emphasis: {
            itemStyle: { color: '#5a87a9' } // Slightly darker on hover
          }
        }, 
        { 
          value: 390,  // Approximate value from the study
          itemStyle: { color: primaryColor },
          emphasis: {
            itemStyle: { color: '#e44522' } // Slightly darker on hover
          }
        }
      ],
      type: 'bar',
      barWidth: '50%', // Make bars slightly wider
      showBackground: true, // Add subtle background to bars
      backgroundStyle: {
        color: 'rgba(220, 220, 220, 0.2)'
      },
      // Add standard error markers (simple version)
      markLine: {
        silent: true,
        symbol: 'none',
        lineStyle: {
          type: 'solid',
          width: 1.5,
          color: '#666'
        },
        data: [
          [
            { yAxis: 195, x: '16.5%' }, // SE for conventional (approx)
            { yAxis: 267, x: '16.5%' }
          ],
          [
            { yAxis: 335, x: '83.5%' }, // SE for SAG (approx)
            { yAxis: 445, x: '83.5%' }
          ]
        ]
      },
      // Add small crossbars to error bars
      markLine: {
        silent: true,
        symbol: ['none', 'none'],
        lineStyle: {
          type: 'solid',
          color: '#666',
          width: 1.5
        },
        data: [
          [{ xAxis: 0, yAxis: 195 }, { xAxis: 0, yAxis: 267 }], // Error bar for conventional
          [{ xAxis: 1, yAxis: 335 }, { xAxis: 1, yAxis: 445 }], // Error bar for SAG
          [{ xAxis: -0.05, yAxis: 195 }, { xAxis: 0.05, yAxis: 195 }], // Bottom crossbar for conventional
          [{ xAxis: -0.05, yAxis: 267 }, { xAxis: 0.05, yAxis: 267 }], // Top crossbar for conventional
          [{ xAxis: 0.95, yAxis: 335 }, { xAxis: 1.05, yAxis: 335 }], // Bottom crossbar for SAG
          [{ xAxis: 0.95, yAxis: 445 }, { xAxis: 1.05, yAxis: 445 }]  // Top crossbar for SAG
        ]
      },
      // Add markPoint at the series level
      markPoint: {
        symbol: 'circle',
        symbolSize: symbolSize,
        itemStyle: {
          color: '#fff',
          borderColor: primaryColor,
          borderWidth: isMobile ? 2 : 3 // Thinner border on mobile
        },
        label: {
          color: primaryColor,
          fontSize: fontSize,
          fontWeight: 'bold',
          padding: [padding, padding, padding, padding]
        },
        data: [
          { 
            name: '+69%', 
            value: '+69%', 
            xAxis: 1, 
            yAxis: 470, // Updated position above the bar
            label: { show: true, formatter: '{b}' } 
          }
        ]
      }
    }]
  };

  myChart.setOption(option);

  // Add citation text below the chart
  const addCitation = () => {
    const bentoCard = chartDom.closest('.bento-card');
    let citation = bentoCard.querySelector('.chart-citation');
    
    if (!citation) {
      citation = document.createElement('div');
      citation.className = 'chart-citation';
      citation.innerHTML = 'Source: Fanelli S, et al. Int J Clin Nutr Diet 4 (2018): 134';
      bentoCard.appendChild(citation);
    }
  };
  
  // Add citation after a short delay to ensure chart is rendered
  setTimeout(addCitation, 500);

  // Handle window resize events
  window.addEventListener('resize', function() {
    // Resize chart
    myChart.resize();
    
    // Check if we need to update for mobile vs desktop
    const newIsMobile = isCompactChart(chartDom);
    if (newIsMobile !== isMobile) {
      // Re-initialize chart with new dimensions
      setTimeout(initClinicalChart, 300); // Small delay to avoid flickering
    }
  });
}

// Initialize the second chart after the DOM is loaded

// --- ECharts: Placebo vs Extramel Grouped Bar Chart ---
function initPlaceboExtramelChart() {
  const chartDom = document.getElementById('placebo-extramel-chart');
  if (!chartDom || typeof echarts === 'undefined') {
    return;
  }

  // Get theme colors
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#ee4d2d'; // Fallback orange/red
  const placeboColor = '#6c99bb'; // Blue color from image
  
  // Use the compact layout when the chart box is narrow
  const isMobile = isCompactChart(chartDom);
  
  // Set responsive sizes based on device
  const symbolSize = isMobile ? 40 : 70; // Smaller circles on mobile
  const fontSize = isMobile ? 16 : 25;   // Smaller text on mobile
  const padding = isMobile ? 2 : 4;      // Less padding on mobile

  const myChart = echarts.init(chartDom);
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' }
    },
    legend: { // Add legend based on image
      data: ['Placebo', "Eslite's SOD"]
    },
    grid: { // Adjust padding
      left: '6%', // Set left padding to 6%
      right: '6%', // Set right padding to 6%
      bottom: '10%', // Increase bottom padding for multi-line labels
      top: '18%',    // Moderate top padding to accommodate markers
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['Stress\nPerceived\n(Lower is Better)', 'Mood Changes &\nIrritability\n(Lower is Better)', 'Mental\nFocus\n(Higher is Better)', 'Physical\nFatigue\n(Lower is Better)'],
      axisLabel: {
        interval: 0, // Show all labels
        lineHeight: 16 // Adjust line height for multi-line labels
      }
    },
    yAxis: {
      type: 'value',
      name: 'Score / Level', // Generic Y-axis label
      min: 0,
      max: 100,
      interval: 25
    },
    series: [
      {
        name: 'Placebo',
        type: 'bar',
        data: [70, 95, 55, 92], // Approximate values from image
        itemStyle: { color: placeboColor }
      },
      {
        name: "Eslite's SOD",
        type: 'bar',
        data: [38, 29, 82, 66], // Approximate values from image
        itemStyle: { color: primaryColor },
        markPoint: {
          symbol: 'circle',
          symbolSize: symbolSize, // Use responsive size based on device
          itemStyle: {
            color: '#fff',
            borderColor: primaryColor,
            borderWidth: isMobile ? 2 : 3 // Thinner border on mobile
          },
          label: {
            color: primaryColor,
            fontSize: fontSize, // Use responsive size based on device
            fontWeight: 'bold',
            padding: [padding, padding, padding, padding] // Use responsive padding
          },
          data: [
            // Position circles above the bars - higher on desktop, closer on mobile
            { 
              name: '-46%', 
              value: '-46%', 
              xAxis: 0, 
              yAxis: isMobile ? 48 : 55, // Higher on desktop
              label: { show: true, formatter: '{b}' } 
            },
            { 
              name: '-69%', 
              value: '-69%', 
              xAxis: 1, 
              yAxis: isMobile ? 39 : 45, // Higher on desktop
              label: { show: true, formatter: '{b}' } 
            },
            { 
              name: '+49%', 
              value: '+49%', 
              xAxis: 2, 
              yAxis: isMobile ? 92 : 100, // Higher on desktop
              label: { show: true, formatter: '{b}' } 
            },
            { 
              name: '-28%', 
              value: '-28%', 
              xAxis: 3, 
              yAxis: isMobile ? 76 : 85, // Higher on desktop
              label: { show: true, formatter: '{b}' } 
            }
          ]
        }
      }
    ]
  };

  myChart.setOption(option);

  // Handle window resize events
  window.addEventListener('resize', function() {
    // Resize chart
    myChart.resize();
    
    // Check if we need to update for mobile vs desktop
    const newIsMobile = isCompactChart(chartDom);
    if (newIsMobile !== isMobile) {
      // Re-initialize chart with new dimensions
      setTimeout(initPlaceboExtramelChart, 300); // Small delay to avoid flickering
    }
  });
}

// --- ECharts: Stress Reduction Chart (PSS-14) ---
function initStressReductionChart() {
  const chartDom = document.getElementById('stress-reduction-chart');
  if (!chartDom || typeof echarts === 'undefined') {
    return;
  }

  // Get theme colors
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#ee4d2d';
  const placeboColor = '#6c99bb';
  
  // Use the compact layout when the chart box is narrow
  const isMobile = isCompactChart(chartDom);
  
  // Set responsive sizes based on device
  const symbolSize = isMobile ? 60 : 70; // Match preclinical chart
  const fontSize = isMobile ? 14 : 20; // Match preclinical chart

  const myChart = echarts.init(chartDom);
  const option = {
    tooltip: {
      trigger: 'item',
      formatter: function(param) {
        const seriesName = param.seriesName;
        const value = param.value;
        
        if (seriesName === 'Placebo') {
          return 'Placebo Group<br/>PSS-14 Score: ' + value;
        } else {
          return 'Eslite Extramel® Group<br/>PSS-14 Score: ' + value + '<br/><span style="opacity: 0.8">(22% lower than placebo, p=0.01)</span>';
        }
      }
    },
    legend: {
      data: ['Placebo', 'Eslite Extramel®'],
      bottom: 0
    },
    grid: {
      left: '3%',
      right: '5%',
      bottom: '15%',
      top: axisNameTop(2, isMobile),
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['After 28 Days Treatment'],
      axisTick: { alignWithLabel: true }
    },
    yAxis: {
      type: 'value',
      name: 'PSS-14 Scale\n(Mean Score)',
      ...axisNameStyle(isMobile),
      min: 0,
      max: 35,
      interval: 5
    },
    series: [
      {
        name: 'Placebo',
        type: 'bar',
        data: [28.3],
        barWidth: '25%',
        itemStyle: {
          color: placeboColor
        }
      },
      {
        name: 'Eslite Extramel®',
        type: 'bar',
        data: [23.6],
        barWidth: '25%',
        barGap: '30%',
        itemStyle: {
          color: primaryColor
        },
        markPoint: {
          symbol: 'circle',
          symbolSize: symbolSize,
          itemStyle: {
            color: '#fff',
            borderColor: primaryColor,
            borderWidth: 2
          },
          label: {
            color: primaryColor,
            fontSize: fontSize,
            fontWeight: 'bold'
          },
          data: [
            {
              name: '-22%',
              coord: [0, 23.6],
              value: '-22%',
              label: { show: true, formatter: '{b}' }
            }
          ]
        }
      }
    ]
  };

  myChart.setOption(option);

  // Add citation text below the chart
  const addCitation = () => {
    const bentoCard = chartDom.closest('.bento-card');
    let citation = bentoCard.querySelector('.chart-citation');
    
    if (!citation) {
      citation = document.createElement('div');
      citation.className = 'chart-citation';
      citation.innerHTML = 'Source: Milesi et al. Nutrition Journal (2009)';
      bentoCard.appendChild(citation);
    }
  };
  
  // Add citation after a short delay
  setTimeout(addCitation, 500);

  // Handle window resize events
  window.addEventListener('resize', function() {
    myChart.resize();
    
    const newIsMobile = isCompactChart(chartDom);
    if (newIsMobile !== isMobile) {
      setTimeout(initStressReductionChart, 300);
    }
  });
}

// --- ECharts: Mood Improvement Chart (FARD) ---
function initMoodImprovementChart() {
  const chartDom = document.getElementById('mood-improvement-chart');
  if (!chartDom || typeof echarts === 'undefined') {
    return;
  }

  // Get theme colors
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#ee4d2d';
  const placeboColor = '#6c99bb';
  
  // Use the compact layout when the chart box is narrow
  const isMobile = isCompactChart(chartDom);
  
  // Set responsive sizes based on device
  const symbolSize = isMobile ? 60 : 70; // Match preclinical chart
  const fontSize = isMobile ? 14 : 20; // Match preclinical chart

  const myChart = echarts.init(chartDom);
  const option = {
    tooltip: {
      trigger: 'item',
      formatter: function(param) {
        const seriesName = param.seriesName;
        const value = param.value;
        
        if (seriesName === 'Placebo') {
          return 'Placebo Group<br/>FARD Irritability Score: ' + value;
        } else {
          return 'Eslite Extramel® Group<br/>FARD Irritability Score: ' + value + '<br/><span style="opacity: 0.8">(63% lower than placebo, p<0.05)</span>';
        }
      }
    },
    legend: {
      data: ['Placebo', 'Eslite Extramel®'],
      bottom: 0
    },
    grid: {
      left: '3%',
      right: '5%',
      bottom: '15%',
      top: axisNameTop(2, isMobile),
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['After 28 Days Treatment'],
      axisTick: { alignWithLabel: true }
    },
    yAxis: {
      type: 'value',
      name: 'FARD Scale\n(Irritability Score)',
      ...axisNameStyle(isMobile),
      min: 0,
      max: 3,
      interval: 0.5
    },
    series: [
      {
        name: 'Placebo',
        type: 'bar',
        data: [2.7],
        barWidth: '25%',
        itemStyle: {
          color: placeboColor
        }
      },
      {
        name: 'Eslite Extramel®',
        type: 'bar',
        data: [1.0],
        barWidth: '25%',
        barGap: '30%',
        itemStyle: {
          color: primaryColor
        },
        markPoint: {
          symbol: 'circle',
          symbolSize: symbolSize,
          itemStyle: {
            color: '#fff',
            borderColor: primaryColor,
            borderWidth: 2
          },
          label: {
            color: primaryColor,
            fontSize: fontSize,
            fontWeight: 'bold'
          },
          data: [
            {
              name: '-63%',
              coord: [0, 1.0],
              value: '-63%',
              label: { show: true, formatter: '{b}' }
            }
          ]
        }
      }
    ]
  };

  myChart.setOption(option);

  // Add citation text below the chart
  const addCitation = () => {
    const bentoCard = chartDom.closest('.bento-card');
    let citation = bentoCard.querySelector('.chart-citation');
    
    if (!citation) {
      citation = document.createElement('div');
      citation.className = 'chart-citation';
      citation.innerHTML = 'Source: Milesi et al. Nutrition Journal (2009)';
      bentoCard.appendChild(citation);
    }
  };
  
  // Add citation after a short delay
  setTimeout(addCitation, 500);

  // Handle window resize events
  window.addEventListener('resize', function() {
    myChart.resize();
    
    const newIsMobile = isCompactChart(chartDom);
    if (newIsMobile !== isMobile) {
      setTimeout(initMoodImprovementChart, 300);
    }
  });
}

// --- ECharts: Mental Focus Chart (STROOP) ---
function initMentalFocusChart() {
  const chartDom = document.getElementById('mental-focus-chart');
  if (!chartDom || typeof echarts === 'undefined') {
    return;
  }

  // Get theme colors
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#ee4d2d';
  const placeboColor = '#6c99bb';
  
  // Use the compact layout when the chart box is narrow
  const isMobile = isCompactChart(chartDom);
  
  // Set responsive sizes based on device
  const symbolSize = isMobile ? 60 : 70; // Match preclinical chart
  const fontSize = isMobile ? 14 : 20; // Match preclinical chart

  const myChart = echarts.init(chartDom);
  const option = {
    tooltip: {
      trigger: 'item',
      formatter: function(param) {
        const seriesName = param.seriesName;
        const value = param.value;
        
        if (seriesName === 'Placebo') {
          return 'Placebo Group<br/>STROOP Score: ' + value + ' (Mental Focus)';
        } else {
          return 'Eslite Extramel® Group<br/>STROOP Score: ' + value + ' (Mental Focus)<br/><span style="opacity: 0.8">(21% higher than placebo, p<0.001)</span>';
        }
      }
    },
    legend: {
      data: ['Placebo', 'Eslite Extramel®'],
      bottom: 0
    },
    grid: {
      left: '3%',
      right: '5%',
      bottom: '15%',
      top: axisNameTop(2, isMobile),
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['After 4 Weeks Treatment'],
      axisTick: { alignWithLabel: true }
    },
    yAxis: {
      type: 'value',
      name: 'STROOP Scale\n(Mental Focus Score)',
      ...axisNameStyle(isMobile),
      min: 0,
      max: 100,
      interval: 20
    },
    series: [
      {
        name: 'Placebo',
        type: 'bar',
        data: [76],
        barWidth: '25%',
        itemStyle: {
          color: placeboColor
        }
      },
      {
        name: 'Eslite Extramel®',
        type: 'bar',
        data: [92],
        barWidth: '25%',
        barGap: '30%',
        itemStyle: {
          color: primaryColor
        },
        markPoint: {
          symbol: 'circle',
          symbolSize: symbolSize,
          itemStyle: {
            color: '#fff',
            borderColor: primaryColor,
            borderWidth: 2
          },
          label: {
            color: primaryColor,
            fontSize: fontSize,
            fontWeight: 'bold'
          },
          data: [
            {
              name: '+21%',
              coord: [0, 92],
              value: '+21%',
              label: { show: true, formatter: '{b}' }
            }
          ]
        }
      }
    ]
  };

  myChart.setOption(option);

  // Add citation text below the chart
  const addCitation = () => {
    const bentoCard = chartDom.closest('.bento-card');
    let citation = bentoCard.querySelector('.chart-citation');
    
    if (!citation) {
      citation = document.createElement('div');
      citation.className = 'chart-citation';
      citation.innerHTML = 'Source: Carillon et al. Nutrients (2014)';
      bentoCard.appendChild(citation);
    }
  };
  
  // Add citation after a short delay
  setTimeout(addCitation, 500);

  // Handle window resize events
  window.addEventListener('resize', function() {
    myChart.resize();
    
    const newIsMobile = isCompactChart(chartDom);
    if (newIsMobile !== isMobile) {
      setTimeout(initMentalFocusChart, 300);
    }
  });
}

// --- ECharts: Physical Fatigue Chart (PREVOST) ---
function initPhysicalFatigueChart() {
  const chartDom = document.getElementById('physical-fatigue-chart');
  if (!chartDom || typeof echarts === 'undefined') {
    return;
  }

  // Get theme colors
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#ee4d2d';
  const placeboColor = '#6c99bb';
  
  // Use the compact layout when the chart box is narrow
  const isMobile = isCompactChart(chartDom);
  
  // Set responsive sizes based on device
  const symbolSize = isMobile ? 60 : 70; // Match preclinical chart
  const fontSize = isMobile ? 14 : 20; // Match preclinical chart

  const myChart = echarts.init(chartDom);
  const option = {
    tooltip: {
      trigger: 'item',
      formatter: function(param) {
        const seriesName = param.seriesName;
        const value = param.value;
        
        if (seriesName === 'Placebo') {
          return 'Placebo Group<br/>PREVOST Score: ' + value + ' (Physical Fatigue)<br/><span style="opacity: 0.8">(Higher = More Fatigue)</span>';
        } else {
          return 'Eslite Extramel® Group<br/>PREVOST Score: ' + value + ' (Physical Fatigue)<br/><span style="opacity: 0.8">(9% lower than placebo, p<0.05)</span>';
        }
      }
    },
    legend: {
      data: ['Placebo', 'Eslite Extramel®'],
      bottom: 0
    },
    grid: {
      left: '3%',
      right: '5%',
      bottom: '15%',
      top: axisNameTop(2, isMobile),
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['After 4 Weeks Treatment'],
      axisTick: { alignWithLabel: true }
    },
    yAxis: {
      type: 'value',
      name: 'PREVOST Scale\n(Physical Fatigue Score)',
      ...axisNameStyle(isMobile),
      min: 0,
      max: 100,
      interval: 20
    },
    series: [
      {
        name: 'Placebo',
        type: 'bar',
        data: [91],
        barWidth: '25%',
        itemStyle: {
          color: placeboColor
        }
      },
      {
        name: 'Eslite Extramel®',
        type: 'bar',
        data: [83],
        barWidth: '25%',
        barGap: '30%',
        itemStyle: {
          color: primaryColor
        },
        markPoint: {
          symbol: 'circle',
          symbolSize: symbolSize,
          itemStyle: {
            color: '#fff',
            borderColor: primaryColor,
            borderWidth: 2
          },
          label: {
            color: primaryColor,
            fontSize: fontSize,
            fontWeight: 'bold'
          },
          data: [
            {
              name: '-9%',
              coord: [0, 83],
              value: '-9%',
              label: { show: true, formatter: '{b}' }
            }
          ]
        }
      }
    ]
  };

  myChart.setOption(option);

  // Add citation text below the chart
  const addCitation = () => {
    const bentoCard = chartDom.closest('.bento-card');
    let citation = bentoCard.querySelector('.chart-citation');
    
    if (!citation) {
      citation = document.createElement('div');
      citation.className = 'chart-citation';
      citation.innerHTML = 'Source: Carillon et al. Nutrients (2014)';
      bentoCard.appendChild(citation);
    }
  };
  
  // Add citation after a short delay
  setTimeout(addCitation, 500);

  // Handle window resize events
  window.addEventListener('resize', function() {
    myChart.resize();
    
    const newIsMobile = isCompactChart(chartDom);
    if (newIsMobile !== isMobile) {
      setTimeout(initPhysicalFatigueChart, 300);
    }
  });
}

// --- ECharts: IV Comparison Chart ---
function initIVComparisonChart() {
  const chartDom = document.getElementById('iv-comparison-chart');
  if (!chartDom || typeof echarts === 'undefined') {
    return;
  }

  // Get theme colors
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#ee4d2d';
  const secondaryColor = '#6c99bb'; // Secondary color for IV Glutathione
  
  // Use the compact layout when the chart box is narrow
  const isMobile = isCompactChart(chartDom);
  
  // Set responsive sizes based on device
  const fontSize = isMobile ? 12 : 14;

  const myChart = echarts.init(chartDom);
  const option = {
    title: {
      text: isMobile
        ? 'Pilot Study: 7-Day Oral S-Acetyl\nvs Single-Dose IV Glutathione'
        : 'Pilot Study: 7-Day Oral S-Acetyl vs Single-Dose IV Glutathione',
      left: 'center',
      top: 10,
      textStyle: {
        fontSize: isMobile ? 14 : 16,
        lineHeight: isMobile ? 18 : 20,
        fontWeight: 500
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: function(params) {
        let result = params[0].axisValue + '<br/>';
        
        params.forEach(param => {
          result += param.marker + param.seriesName + ': <b>' + param.value + '%</b><br/>';
        });
        
        return result;
      }
    },
    legend: {
      data: ['Oral S-Acetyl Glutathione', 'IV Glutathione'],
      top: isMobile ? 58 : 40,
      textStyle: {
        fontSize: fontSize
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '10%',
      top: isMobile ? 124 : '25%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      axisTick: { alignWithLabel: true },
      data: [
        'F2-Isoprostane\n(↓ better)',
        '8-oxo-dG\n(↓)',
        'SOD-1\n(↑)',
        'TBARS\n(↓)'
      ],
      axisLabel: {
        interval: 0,
        fontSize: fontSize,
        lineHeight: 14
      }
    },
    yAxis: {
      type: 'value',
      name: '% Improvement vs Baseline',
      ...axisNameStyle(isMobile)
    },
    series: [
      {
        name: 'Oral S-Acetyl Glutathione',
        type: 'bar',
        data: [40, 15, 20, 0],
        itemStyle: { color: primaryColor },
        emphasis: { focus: 'series' }
      },
      {
        name: 'IV Glutathione',
        type: 'bar',
        data: [10, 10, 5, 5],
        itemStyle: { color: secondaryColor },
        emphasis: { focus: 'series' }
      }
    ]
  };

  myChart.setOption(option);

  // Add citation text below the chart
  const addCitation = () => {
    const bentoCard = chartDom.closest('.bento-card');
    let citation = bentoCard.querySelector('.chart-citation');
    
    if (!citation) {
      citation = document.createElement('div');
      citation.className = 'chart-citation';
      citation.innerHTML = 'Source: 2011 pilot study (N=6) comparing oral S-Acetyl Glutathione vs IV therapy';
      bentoCard.appendChild(citation);
    }
  };
  
  // Add citation after a short delay
  setTimeout(addCitation, 500);

  // Handle window resize events
  window.addEventListener('resize', function() {
    myChart.resize();
    
    const newIsMobile = isCompactChart(chartDom);
    if (newIsMobile !== isMobile) {
      setTimeout(initIVComparisonChart, 300);
    }
  });
}

// --- Cart Count Updates ---
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
        if (cart.item_count === 0) {
          element.classList.add('cart-count--empty');
        } else {
          element.classList.remove('cart-count--empty');
        }
      });
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}


// --- ECharts: load the 1 MB library only on pages that draw a chart ---
const ECHARTS_SRC = 'https://cdn.jsdelivr.net/npm/echarts@5.6.0/dist/echarts.min.js';
const CHART_IDS = ['clinical-chart', 'iv-comparison-chart', 'mental-focus-chart', 'mood-improvement-chart', 'physical-fatigue-chart', 'placebo-extramel-chart', 'preclinical-chart', 'stress-reduction-chart'];
const CHART_INITS = [initPreclinicalChart, initClinicalChart, initPlaceboExtramelChart, initStressReductionChart, initMoodImprovementChart, initMentalFocusChart, initPhysicalFatigueChart, initIVComparisonChart];

function initStudyCharts() {
  const hasChart = CHART_IDS.some(id => document.getElementById(id));
  if (!hasChart) return;

  const runCharts = () => CHART_INITS.forEach(init => init());
  if (typeof echarts !== 'undefined') {
    runCharts();
    return;
  }

  const script = document.createElement('script');
  script.src = ECHARTS_SRC;
  script.async = true;
  script.onload = runCharts;
  document.head.appendChild(script);
}
document.addEventListener('DOMContentLoaded', initStudyCharts);

// --- Buy Now Button (Stealth Implementation) ---
// Every cart form is a .buy-now-form, used only on the product page. A submit adds to cart, then opens
// the cart, so the shopper reviews the order there before checkout.
// Buy boxes with a supply ladder also update every total shown for that form.
function formatPeso(cents) {
  return '₱' + Math.round(cents / 100).toLocaleString('en-PH');
}

function initBuyNowButtons() {
  const buyNowForms = document.querySelectorAll('.buy-now-form');

  buyNowForms.forEach(form => {
    const ownTotals = () => Array.from(document.querySelectorAll('[data-buy-total]'))
      .filter(el => el.closest('form') === form || (form.id && el.dataset.buyTotalFor === form.id));

    form.querySelectorAll('.offer-ladder__input').forEach(input => {
      input.addEventListener('change', () => {
        const total = formatPeso(Number(input.dataset.total));
        ownTotals().forEach(el => { el.textContent = total; });
      });
    });

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const formData = new FormData(form);
      const submitButtons = Array.from(form.querySelectorAll('button[type="submit"]'));
      if (form.id) submitButtons.push(...document.querySelectorAll('button[type="submit"][form="' + form.id + '"]'));
      const adding = form.dataset.addingLabel || 'Adding…';

      // Prevent double submissions during async operation
      submitButtons.forEach(button => {
        button.disabled = true;
        button.dataset.label = button.innerHTML;
        button.textContent = adding;
      });

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (!response.ok) throw new Error('Cart add failed: ' + response.status);
        return response.json();
      })
      .then(() => {
        updateCartCount();
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        submitButtons.forEach(button => {
          button.disabled = false;
          button.innerHTML = button.dataset.label;
        });
        alert(form.dataset.errorLabel || 'Sorry, there was an error. Please try again.');
      });
    });
  });
}

// Restore buy buttons when the shopper returns from the cart with the Back button
window.addEventListener('pageshow', function(event) {
  if (!event.persisted) return;
  document.querySelectorAll('button[data-label]').forEach(button => {
    button.disabled = false;
    button.innerHTML = button.dataset.label;
  });
});

document.addEventListener('DOMContentLoaded', function() {
  initBuyNowButtons();
  updateCartCount();
});

// Sync cart count across browser tabs
document.addEventListener('visibilitychange', function() {
  if (!document.hidden) {
    updateCartCount();
  }
});

// --- YouTube click-to-load: swap the thumbnail for the player when the shopper presses play ---
document.addEventListener('click', function(event) {
  const facade = event.target.closest('[data-yt-facade]');
  if (!facade) return;
  const iframe = document.createElement('iframe');
  iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(facade.dataset.ytFacade) + '?autoplay=1&modestbranding=1&rel=0&playsinline=1';
  iframe.title = facade.dataset.ytTitle || 'YouTube video player';
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
  iframe.allowFullscreen = true;
  facade.replaceWith(iframe);
  iframe.focus();
});
